import React from "react";
import ReleaseNotesCard from "@/components/ReleaseNotesCard";

export default function ReleaseNotes() {
    return (
        <div className="space-y-6" data-testid="release-notes-page">
            <div>
                <h1 className="font-display text-4xl font-bold tracking-tight text-slate-900">Release Notes</h1>
                <p className="mt-1 text-sm text-slate-600">What's new and recently changed in MICM.</p>
            </div>
            <ReleaseNotesCard />
        </div>
    );
}
